import { render, staticRenderFns } from "./Pruefungenliste.vue?vue&type=template&id=0a854a25&"
import script from "./Pruefungenliste.vue?vue&type=script&lang=js&"
export * from "./Pruefungenliste.vue?vue&type=script&lang=js&"
import style0 from "./Pruefungenliste.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports